import { randomInt } from './number'

export const randomString = (len) => {
  let buf = []
    , chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    , charlen = chars.length;

  for (let i = 0; i < len; ++i) {
    buf.push(chars[randomInt(0, charlen - 1)]);
  }

  return buf.join('');
}

export const sanitizeFileName = (name) => {
  const ext = name.split('.').pop();
  const extReg =  new RegExp(ext, "i");
  let namePart = name.replace(extReg, '')
                     .replace(/[^a-z0-9_-]/gi, '-')
                     .replace(/-{2,}|_{2,}/gi, '-')
                     .replace(/^-|^_/, '')
                     .replace(/-$|_$/, '')
                     .toLowerCase();
  if (namePart === '') {
    namePart = 'image';
  }
  return `${namePart}.${ext}`;
}

export default {
  randomString,
  sanitizeFileName,
};
